import Vuex from "vuex";

import { appDataStore } from "./appDataStore";
import { userStore } from "./userStore";
import { interactiveStore } from "./interactiveStore";
import { modalsStore } from "./modalsStore";
import { publicStore } from "./publicStore";
import { settingsStore } from "./settingsStore";
import { contactsStore } from "./contactsStore";
import { audioRecorderStore } from "./audioRecorderStore";
import { wizardNewCadenceStore } from "./wizard.new.cadence.store";
import { importContactStore } from "./import.contact.store";
import { uploaderStore } from "./uploader.store";
import { votingStore } from "./votingStore";
import { interpellationsStore } from "./interpellationsStore";
import { placeholderStore } from "./placeholderStore"; 
import { calendarStore } from "./calendarStore";
import { speechTimerStore } from "./speechTimerStore";
import { i18nStore } from "./i18nStore";
import { roomMapStore } from "./roomMapStore";
import { clientInvoiceDataStore } from "./client.invoice.data.store";
import { countryStore } from "./countryStore";
import { discussionProfileStore } from "./discussionProfileStore";
import { activityStore } from "./activityStore";

const store = new Vuex.Store({
    modules: {
        activityStore: activityStore,
        appStore: appDataStore,
        userStore: userStore,
        interactiveStore: interactiveStore,
        modals: modalsStore,
        public: publicStore,
        settings: settingsStore,
        contacts: contactsStore,
        audioRecorder: audioRecorderStore,
        wizardNewCadence: wizardNewCadenceStore,
        importContactStore: importContactStore,
        uploaderStore: uploaderStore,
        votingStore: votingStore,
        interpellationsStore: interpellationsStore,
        placeholderStore: placeholderStore,
        calendarStore: calendarStore,
        speechTimerStore: speechTimerStore,
        i18nStore: i18nStore,
        roomMap: roomMapStore,
        clientInvoiceDataStore: clientInvoiceDataStore,
        countryStore: countryStore,
        discussionProfileStore: discussionProfileStore
    },
});

export default store;
